import { Entity } from "../../../core/commons/entity";
import { Address } from "../address";
/**
 * Created by Lauta on 18/4/2017.
 */

export class Ministry implements Entity {
  public id: number = null;
  public name: string = "";
  public address: Address = null;

  constructor(value: Object = {}) {
    Object.assign(this, value);
    this.address = new Address(this.address);
  }

  toString(): string {
    return name;
  }
 
  equals(ministry: Ministry): boolean{
    if (ministry) {
        return (this.id == ministry.id);
    }
    return false;
}
}



// WEBPACK FOOTER //
// ./src/app/profile/domain/ministry/ministry.ts